/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface FieldChange
 */
export interface FieldChange {
    /**
     * 
     * @type {string}
     * @memberof FieldChange
     */
    fieldName: string;
    /**
     * The value - can be a string, object
     * @type {string | object}
     * @memberof FieldChange
     */
    oldValue?: string | object;
    /**
     * The value - can be a string, object
     * @type {string | object}
     * @memberof FieldChange
     */
    newValue?: string | object;
    /**
     * 
     * @type {string}
     * @memberof FieldChange
     */
    changeType: FieldChangeChangeTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum FieldChangeChangeTypeEnum {
    ADDED = 'ADDED',
    REMOVED = 'REMOVED',
    MODIFIED = 'MODIFIED',
    MOVED = 'MOVED',
    UNCHANGED = 'UNCHANGED'
}



